/**
 * @description: 歌曲点播数据汇总报表
 * @author: hwx
*/
<template>
    <div class="or-gdh-report">
        <div class="gdh-list">
            <el-form :inline="true" :model="list_form">
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="歌星">
                    <el-input v-model="list_form.songs_player" placeholder="请输入歌星名"></el-input>
                </el-form-item>
                <el-form-item label="歌曲名称">
                    <el-input v-model="list_form.songs_name" placeholder="请输入歌曲名"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="getListTable(1)">查询</el-button>
                    <el-button @click="gdhExportSet">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="songs_player" label="歌星"></el-table-column>
                <el-table-column prop="songs_name" label="歌曲名称"></el-table-column>
                <el-table-column prop="play_num" label="点播次数"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getListTable">
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div class="export-wrap" ref="gdh_list_export">
                <h3>请选择导出报表需要的显示的字段</h3>
                <el-checkbox :indeterminate="gdh_export_sign" v-model="gdh_export_all" @change="gdhExportAll">全选</el-checkbox>
                <el-checkbox-group v-model="gdh_export_ids" @change="gdhExportChange">
                    <el-checkbox label="songs_player">歌星</el-checkbox>
                    <el-checkbox label="songs_name">歌曲名称</el-checkbox>
                    <el-checkbox label="play_num">点播次数</el-checkbox>
                </el-checkbox-group>
                <h3>请选择导出报表的文件格式</h3>
                <el-radio v-model="gdh_export_type" label="1">excel表格</el-radio>
                <el-radio v-model="gdh_export_type" label="2">pdf文件</el-radio>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                list_form: {
                    shop_id: '',
                    songs_player: '',
                    songs_name: ''
				},
				list_page: 1,
				list_total: 0,
				list_table: [],
                gdh_export_sign: false,
				gdh_export_all: false,
                gdh_export_ids: [],
                gdh_export_list: ['songs_player', 'songs_name', 'play_num'],
                gdh_export_type: '1',
            }
        },
        mounted: function() {
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id
            })
        },
        methods: {
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 列表
			getListTable: function(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('Songs/getShopDgData', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "shop_id": _this.list_form.shop_id,
                            "songs_player": _this.list_form.songs_player,
                            "songs_name": _this.list_form.songs_name
						}
					},
					"comment": ""
				})
				.then(res => {
					_this.loading = false
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.total)
						}
						_this.list_table = res.data.response.result.rows
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this)
						layer.msg(res.data.response.error_msg)
					}
				})
				.catch(err => {
					layer.msg("出错啦")
				})
			},
            // 导出
            gdhExportAll(val) {
				this.gdh_export_ids = val ? this.gdh_export_list : [];
				this.gdh_export_sign = false;
			},
			gdhExportChange(val) {
				const len = val.length;
				this.gdh_export_all = len === this.gdh_export_list.length;
				this.gdh_export_sign = len > 0 && len < this.gdh_export_list.length;
			},
            gdhExportSet: function() {
                const _this = this;

                Vue.axios.post('FinanceReport/getExportSet', {
					"header": Vue.request_header,
					"request": {
						"param": {
                            "report_type": "Songs/exportShopDgData"
                        }
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(res.data.response.result) {
                            _this.gdh_export_ids = res.data.response.result.export_fields;
                            _this.gdh_export_type = res.data.response.result.export_type;
                        } else {
                            _this.gdh_export_ids = _this.gdh_export_list;
                            _this.gdh_export_type = '1';
                        }
                        _this.gdhExportChange(_this.gdh_export_ids);
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
                });
                // 弹窗
                layer.confirm('', {
                    skin: 'public-alert-skin',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['800px', ''], // 宽高
                    content: $(_this.$refs.gdh_list_export)
                }, function() {
                    _this.gdhExport();
                });
            },
            gdhExport: function() {
                window.location.href = Vue.ctUrl + "Songs/exportShopDgData" +
                    "?shop_id=" + this.list_form.shop_id +
                    "&songs_player=" + this.list_form.songs_player +
                    "&songs_name=" + this.list_form.songs_name +
                    "&export_fields=" + JSON.stringify(this.gdh_export_ids) +
                    "&export_type=" + this.gdh_export_type
                layer.closeAll()
                layer.msg("导出成功！")
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>